import { EditFilled } from '@ant-design/icons';
import { ReactNode } from 'react';

import { ShiftListItemDto, ShiftType } from '@clh/api-client';

import EditShiftRate from '../edit-shift-rate';

export const createPayRateFieldRenderer = (
    selection: ShiftListItemDto,
    isEditing: boolean,
    onEdit: () => void,
    onClose: () => void
): ((payRate: number) => ReactNode) => {
    const renderPayRate = (payRate: number) => {
        if (payRate === 0) {
            return <>0</>;
        }

        if (isEditing) {
            return (
                <EditShiftRate
                    payRate={payRate}
                    totalRate={selection.totalRate}
                    close={onClose}
                />
            );
        }

        const displayText =
            selection.shiftType === ShiftType.OnCall && selection.onCallShift
                ? `$${(payRate / 100).toFixed(2)} (called-in) / $${(
                      selection.onCallShift.payRate / 100
                  ).toFixed(2)} (on-call)`
                : `$${(payRate / 100).toFixed(2)}`;

        return (
            <div>
                {displayText}
                <a onClick={onEdit}>
                    <EditFilled />
                </a>
            </div>
        );
    };

    renderPayRate.displayName = 'PayRateFieldRenderer';
    return renderPayRate;
};
